export default {"src":"/_next/static/media/0xcf66eb3d546f0415b368d98a95eaf56ded7aa752.e0a56871.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};